import { type ID, type LabelValue, type WithId } from "@client/types";
import classnames from "classnames";
import * as React from "react";
import GridFilter from "../../Filter/component";
import FluidGrid, { type FluidGridItem, type FluidGridProps } from "../component";

import "./style.less";

export type WithFilterFluidGridProps<
  TItemProps extends {},
  TItem extends FluidGridItem = FluidGridItem
> = FluidGridProps<TItemProps, TItem> & {
  activeTag: string;
  noItemsMessage?: string;
  tagsClassName: string;
  orientation?: "horizontal" | "vertical";
  onTagClick: (value: string) => void;
  tags: LabelValue<string>[];

  onSearch?: (text: string) => void;
  searchText?: string;

  renderGrid?: (props: FluidGridProps<TItemProps, TItem>) => React.ReactElement;

  showTags: boolean;
};

const WithFilterFluidGrid = <TItemProps extends {}, TItem extends WithId<ID>>({
  className,
  activeTag,
  noItemsMessage,
  tagsClassName,
  orientation,
  onTagClick,
  onSearch,
  searchText,
  showTags,
  tags,
  ...props
}: WithFilterFluidGridProps<TItemProps, TItem>) => (
  <div className={classnames(className, "wsc_fluid_grid_with_filter", orientation || "horizontal")}>
    {noItemsMessage && !props.items.length && !searchText ? (
      <div className="no_items_message">{noItemsMessage}</div>
    ) : (
      <>
        {showTags && (
          <GridFilter
            activeTag={activeTag}
            className={tagsClassName}
            containerClassName="wsc_fluid_grid_filter"
            onTagClick={onTagClick}
            onSearch={onSearch}
            searchText={searchText}
            tags={tags}
          />
        )}

        {props.renderGrid ? props.renderGrid(props) : <FluidGrid {...props} />}
      </>
    )}
  </div>
);

export default WithFilterFluidGrid;
